import React, { useState } from 'react';
import { Database, Download, Filter } from 'lucide-react';

export function RegularListsView() {
  const [filters, setFilters] = useState({
    dataSource: '',
    listType: '',
    state: '',
    county: '',
    minEquity: '',
    ownerStatus: ''
  });

  const handlePullList = () => {
    console.log('Pulling regular list with filters:', filters);
    alert(`Pull Regular List\n\nFilters:\nData Source: ${filters.dataSource || 'Not selected'}\nList Type: ${filters.listType || 'All'}\nState: ${filters.state || 'All'}\nCounty: ${filters.county || 'All'}\nMin Equity: $${filters.minEquity || '0'}\nOwner Status: ${filters.ownerStatus || 'All'}\n\nThis will be connected to data provider API.`);
  };

  const handleClearFilters = () => {
    setFilters({
      dataSource: '',
      listType: '',
      state: '',
      county: '',
      minEquity: '',
      ownerStatus: ''
    });
  };

  return (
    <div className="space-y-6">
      {/* Page Header */}
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-tdb-primary">Regular Lists</h1>
          <p className="text-gray-600 mt-1">Pull targeted lead lists from various data sources</p>
        </div>
      </div>

      {/* Main Filter Card */}
      <div className="bg-gradient-to-br from-blue-50 to-indigo-50 rounded-2xl shadow-lg p-8 border-2 border-blue-200">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-12 h-12 bg-blue-500 rounded-xl flex items-center justify-center">
            <Database className="w-6 h-6 text-white" />
          </div>
          <div>
            <h2 className="text-2xl font-bold text-tdb-primary">Filter Criteria</h2>
            <p className="text-sm text-gray-600">Select your target lead parameters</p>
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 space-y-4">
          {/* Data Source Selection */}
          <div>
            <h3 className="text-sm font-bold text-gray-700 mb-3 flex items-center">
              <span className="w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-xs font-bold mr-2">1</span>
              Data Source
            </h3>
            <select
              value={filters.dataSource}
              onChange={(e) => setFilters({...filters, dataSource: e.target.value})}
              className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
            >
              <option value="">Select Data Source *</option>
              <option value="foreclosure">Pre-Foreclosure</option>
              <option value="probate">Probate</option>
              <option value="divorce">Divorce</option>
              <option value="absentee-owner">Absentee Owner</option>
              <option value="vacant">Vacant Properties</option>
              <option value="code-violations">Code Violations</option>
              <option value="wholesale">Wholesale Leads</option>
              <option value="expired-listings">Expired Listings</option>
              <option value="fsbo">FSBO (For Sale By Owner)</option>
            </select>
          </div>

          {/* List Type */}
          <div className="pt-4 border-t border-gray-200">
            <h3 className="text-sm font-bold text-gray-700 mb-3 flex items-center">
              <span className="w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-xs font-bold mr-2">2</span>
              List Type & Motivation
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm text-gray-600 font-medium block mb-2">List Type</label>
                <select
                  value={filters.listType}
                  onChange={(e) => setFilters({...filters, listType: e.target.value})}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">All Lists</option>
                  <option value="motivated">Motivated Sellers</option>
                  <option value="distressed">Distressed Properties</option>
                  <option value="high-equity">High Equity</option>
                  <option value="cash-buyer">Cash Buyers</option>
                  <option value="investor">Investor Owned</option>
                </select>
              </div>

              <div>
                <label className="text-sm text-gray-600 font-medium block mb-2">Owner Status</label>
                <select
                  value={filters.ownerStatus}
                  onChange={(e) => setFilters({...filters, ownerStatus: e.target.value})}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">All Owners</option>
                  <option value="absentee">Absentee Owner</option>
                  <option value="in-state">In-State Owner</option>
                  <option value="out-of-state">Out-of-State Owner</option>
                  <option value="corporate">Corporate Owned</option>
                </select>
              </div>
            </div>
          </div>

          {/* Location Filters */}
          <div className="pt-4 border-t border-gray-200">
            <h3 className="text-sm font-bold text-gray-700 mb-3 flex items-center">
              <span className="w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-xs font-bold mr-2">3</span>
              Location
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="text-sm text-gray-600 font-medium block mb-2">State *</label>
                <select
                  value={filters.state}
                  onChange={(e) => setFilters({...filters, state: e.target.value})}
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                >
                  <option value="">Select State</option>
                  <option value="FL">Florida</option>
                  <option value="GA">Georgia</option>
                  <option value="TX">Texas</option>
                  <option value="NC">North Carolina</option>
                  <option value="SC">South Carolina</option>
                  <option value="AL">Alabama</option>
                  <option value="TN">Tennessee</option>
                </select>
              </div>

              <div>
                <label className="text-sm text-gray-600 font-medium block mb-2">County (Optional)</label>
                <input
                  type="text"
                  value={filters.county}
                  onChange={(e) => setFilters({...filters, county: e.target.value})}
                  placeholder="e.g., Orange, Hillsborough"
                  className="w-full px-4 py-3 border-2 border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Additional Criteria */}
          <div className="pt-4 border-t border-gray-200">
            <h3 className="text-sm font-bold text-gray-700 mb-3 flex items-center">
              <span className="w-6 h-6 bg-blue-100 text-blue-600 rounded-full flex items-center justify-center text-xs font-bold mr-2">4</span>
              Additional Criteria
            </h3>
            <div>
              <label className="text-sm text-gray-600 font-medium block mb-2">Minimum Equity</label>
              <div className="relative">
                <span className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-500">$</span>
                <input
                  type="number"
                  value={filters.minEquity}
                  onChange={(e) => setFilters({...filters, minEquity: e.target.value})}
                  placeholder="0"
                  className="w-full pl-8 pr-4 py-3 border-2 border-gray-300 rounded-xl text-sm focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                />
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="pt-6 border-t border-gray-200 flex space-x-4">
            <button
              onClick={handleClearFilters}
              className="flex items-center justify-center space-x-2 px-6 py-3 border-2 border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-all font-semibold"
            >
              <Filter className="w-5 h-5" />
              <span>Clear Filters</span>
            </button>

            <button
              onClick={handlePullList}
              disabled={!filters.dataSource || !filters.state}
              className={`flex-1 flex items-center justify-center space-x-2 px-6 py-4 rounded-xl transition-all font-bold shadow-lg ${
                (filters.dataSource && filters.state)
                  ? 'bg-blue-500 text-white hover:bg-blue-600'
                  : 'bg-gray-300 text-gray-500 cursor-not-allowed'
              }`}
            >
              <Download className="w-6 h-6" />
              <span>Pull Lead List</span>
            </button>
          </div>
        </div>

        {/* Stats Preview */}
        <div className="mt-6 bg-white rounded-xl p-4">
          <div className="grid grid-cols-3 gap-4 text-center">
            <div>
              <div className="text-sm text-gray-600">Estimated Records</div>
              <div className="text-2xl font-bold text-blue-600">~1,850</div>
            </div>
            <div>
              <div className="text-sm text-gray-600">Avg Equity</div>
              <div className="text-2xl font-bold text-indigo-600">$125k</div>
            </div>
            <div>
              <div className="text-sm text-gray-600">Cost Per Record</div>
              <div className="text-2xl font-bold text-green-600">$0.35</div>
            </div>
          </div>
        </div>
      </div>

      {/* Recent Pulls */}
      <div className="bg-white rounded-2xl shadow-lg p-6">
        <h3 className="text-xl font-bold text-tdb-primary mb-4">Recent List Pulls</h3>
        <div className="space-y-3">
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
            <div>
              <div className="font-semibold text-gray-800">Foreclosure - Florida</div>
              <div className="text-sm text-gray-600">High Equity | Out-of-State Owners</div>
            </div>
            <div className="text-right">
              <div className="text-sm text-gray-600">Nov 28, 2025</div>
              <div className="font-bold text-blue-600">412 records</div>
            </div>
          </div>
          <div className="flex items-center justify-between p-4 bg-gray-50 rounded-xl">
            <div>
              <div className="font-semibold text-gray-800">Probate - Georgia</div>
              <div className="text-sm text-gray-600">Motivated Sellers | All Counties</div>
            </div>
            <div className="text-right">
              <div className="text-sm text-gray-600">Nov 25, 2025</div>
              <div className="font-bold text-blue-600">678 records</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
